import Projects from "./projects";
import Tasks from './tasksfactory';
import { endOfTomorrow, startOfYesterday, format } from "date-fns";

// provides a sample project with tasks
// bypasses pubsub events
export function createSampleProject() {
	// check if local storage is empty
	const existingProjects = JSON.parse(localStorage.getItem('todoItems')) || [];

	// if there are no existing projects in local storage
	// create a sample project
	if (existingProjects.length === 0) {
		const sampleProject = Projects({name: 'Sample Project'});

		// add the sample project to the array
		existingProjects.push(sampleProject);

		// create and add tasks to the sample project
		// important task + today's date
		const sampleTask1 = Tasks({
			projectId: sampleProject.projectId,
			title: 'An important task with today\'s date. Read description!',
			description: 'This sample task has a date that shows the current day when you first load the app. It\'s also marked as important.',
			duedate: format(new Date(), 'yyyy-MM-dd'),
			priority: '3',
			done: false,
		});
		sampleProject.tasks.push(sampleTask1);

		// sample task happening this week
		const sampleTask2 = Tasks({
			projectId: sampleProject.projectId,
			title: 'Happening this week. Check info!',
			description: 'This sample task happens this week when you first load the app, so it should be seen in the Week tab. The project also has some done tasks, check them in the project view, underneath the active tasks.',
			duedate: format(endOfTomorrow(), 'yyyy-MM-dd'),
			priority: '2',
			done: false,
		});
		sampleProject.tasks.push(sampleTask2);

		// sample task happening this week
		const sampleTask3 = Tasks({
			projectId: sampleProject.projectId,
			title: 'A done task',
			description: 'This sample task took place in the past and is marked as done and least important.',
			duedate: format(startOfYesterday(), 'yyyy-MM-dd'),
			priority: '1',
			done: true,
		});
		sampleProject.tasks.push(sampleTask3);

		// sample task happening this week, also done
		const sampleTask4 = Tasks({
			projectId: sampleProject.projectId,
			title: 'Another done task',
			description: 'This sample task took place in the past and is marked as done and least important.',
			duedate: format(startOfYesterday(), 'yyyy-MM-dd'),
			priority: '2',
			done: true,
		});
		sampleProject.tasks.push(sampleTask4);

		// save the project to local storage
		localStorage.setItem('todoItems', JSON.stringify(existingProjects));

		return sampleProject;
	} else {
		console.log('Projects exist in local storage');
	}
}
